import DotActiveIcon from '../../../assets/dot_active.svg';
import DotIcon from '../../../assets/dot.svg';
import Quote from './Quote';
import React from 'react';
import Slider from 'react-slick';
import quotesMap from '../../../../content/quotes.yaml';
import styled from 'styled-components';
import { useIntl } from 'gatsby-plugin-intl';

const Container = styled.div`
  margin-bottom: 6rem;

  @media ${props => props.theme.breakpoints.md} {
    margin-bottom: 0;

    .slick-slide {
      padding-right: 6rem;
    }
  }
`;

const Dot = styled.div`
  display: inline-block;
  height: 2rem;
  width: 2rem;
  background-image: url(${DotIcon});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

const ForestSliderDots = styled.ul`
  text-align: center;
  bottom: -5rem;

  .slick-active ${Dot} {
    background-image: url(${DotActiveIcon});
  }
`;

const sliderSettings = {
  autoplay: true,
  autoplaySpeed: 6000,
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1200,
  slidesToShow: 2,
  slidesToScroll: 1,
  easing: 'ease-in-out',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        autoplay: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: dots => <ForestSliderDots>{dots}</ForestSliderDots>,
        customPaging: i => <Dot />,
      },
    },
  ],
};

const Quotes = () => {
  const intl = useIntl();
  const quotes = quotesMap[intl.locale];

  return (
    <Container>
      <Slider key="large-quotes-slider" {...sliderSettings}>
        {quotes.map(({ content, quoting, description }) => (
          <Quote key={content} content={content} quoting={quoting} description={description} />
        ))}
      </Slider>
    </Container>
  );
};

export default Quotes;
